<template>
  <button class="category-card group relative bg-surface rounded-2xl shadow-xl hover:scale-105 hover:shadow-2xl overflow-hidden">
    <div class="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent" />
    <div
      class="w-12 h-12 mb-4 absolute"
      :class="isMobileDevice ? 'top-4 left-4' : 'top-6 left-6'"
    >
      <component
        :is="icon"
        class="w-full h-full text-text-tertiary"
      />
    </div>
    <div class="relative z-10">
      <h2 class="text-2xl font-bold mb-2 text-text-primary">
        {{ title }}
      </h2>
      <p
        v-if="!isMobileDevice"
        class="text-text-secondary"
      >
        {{ subtitle }}
      </p>
    </div>
  </button>
</template>

<script setup lang="ts">
import type { Component } from 'vue';
import { useDeviceDetection } from '@/composables/useDeviceDetection';

defineProps<{
  title: string;
  subtitle: string;
  icon: Component;
}>();

const { isMobileDevice } = useDeviceDetection();
</script>
